import { render, staticRenderFns } from "./siteNav.vue?vue&type=template&id=0efafac6"
import script from "./siteNav.vue?vue&type=script&lang=js"
export * from "./siteNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports